import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@auctisync/ui';
import { Link } from 'react-router-dom';
import { SignInForm } from '../../components/SignInForm';
import { authRedirectUrl } from '../../lib/authRedirect';

/**
 * Unauthenticated landing for `admin.auctisync.com`. Super-admin access only;
 * the role gate is enforced by the `/super/dashboard` protected route, not
 * by this form. A non-super user can complete sign-in here and will then be
 * redirected to `/unauthorized`.
 */
export function SuperSignIn() {
  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
      }}
    >
      <Card style={{ width: '100%', maxWidth: '28rem' }}>
        <CardHeader>
          <CardTitle>Super admin sign-in</CardTitle>
          <CardDescription>
            AuctiSync platform ops only. All actions are logged to <code>admin_audit_log</code>.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <SignInForm magicLinkRedirectTo={authRedirectUrl('/auth/callback')} />
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              fontSize: '0.875rem',
              marginTop: '1rem',
            }}
          >
            <Link to="/super/forgot-password" style={{ color: 'var(--brand-primary)' }}>
              Forgot password
            </Link>
            <a
              href="https://help.auctisync.com"
              target="_blank"
              rel="noreferrer"
              style={{ color: 'var(--brand-primary)' }}
            >
              Help Center
            </a>
          </div>
        </CardContent>
      </Card>
    </main>
  );
}
